import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
import { useSelector, useDispatch } from 'react-redux';
import { redirectUrlAction } from '../../middleware/redirectUrlAction';
import { useHistory } from 'react-router-dom';
import useStateRef from 'react-usestateref';
function ShoppingListsTile(props) {
    let history = useHistory();
    const profileDetails = useSelector(state => state.getProfileDetails.profileDetails);
    const ShoppingListDetails = props.data?.[0]?.ContentRuleZone?.[0]?.attributes
    const  mainImage = props.data?.[0]?.ContentRuleZone?.[0]?.menuImage
    const  altText = props.data?.[0]?.ContentRuleZone?.[0]?.attributes?.altText
    const[renderType, setRenderType] = useState("");
    var profile = props.profile;
    const dispatch = useDispatch();
    const [showShoppingList, setShowShoppingList, showShoppingListRef] = useStateRef('');
    useEffect(() => {
        if (profileDetails && profileDetails.userTypeCheck && Object.keys(profileDetails.userTypeCheck).length > 0 && !profileDetails.userTypeCheck.showShoppingLists && profileDetails.userSegment['Punchout Session'] === true ) {
                document.getElementById("shopping-list").classList.remove("d-block")
                document.getElementById("shopping-list").classList.add("d-none")
        }
        if(ShoppingListDetails.renderPosition) {
            setRenderType(ShoppingListDetails.renderPosition)
          }
    }, [profileDetails])
    var shoppingListDetailRef = props.shoppingListDetailRef;
    const handleListLogin = (event) => {
        // event.preventDefault();
        // props.handleListLogin(event)
        dispatch(redirectUrlAction("/account/list"))
    }
    const handleClick = (event) => {
        // event.preventDefault();
        dispatch(redirectUrlAction("/account/list"))
        // if (event.ctrlKey || event.metakey) {
        //     if (profile && profile.transient) {
        //         window.open("/account/login?resume=list", "_blank")
        //     } else {
        //         window.open("/account/list", "_blank")
        //     }
        // } else {
        //     if (profile && profile.transient) {
        //         history.push("/account/login?resume=list")
        //     } else {
        //         history.push("/account/list")
        //     }
        // }
    }
    return (
        <>
            <li id="shopping-list" className={`text-center icon-width-popup popover__wrapper c-list-image d-block ${ShoppingListDetails?.additionalCss ? ShoppingListDetails.additionalCss :"" }`}>
                {renderType === "TextOnly"? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span>
                </Link> 
                    : renderType === "IconOnly" ? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                    {ShoppingListDetails.menuIcon ? <i class={`${ShoppingListDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                </Link>
                    : renderType === "LeftIconThenText" ? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                    {ShoppingListDetails.menuIcon ? <i class={`${ShoppingListDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span>
                </Link> 
                    : renderType === "LeftTextThenIcon" ? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span>
                    {ShoppingListDetails.menuIcon ? <i class={`${ShoppingListDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                </Link> 
                    : renderType === "TextAboveIcon" ? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                    {ShoppingListDetails.menuIcon ? <i class={`${ShoppingListDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span>
                </Link>
                    : renderType === "TextBelowIcon" ? <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}>
                    <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span>
                    {ShoppingListDetails.menuIcon ? <i class={`${ShoppingListDetails.menuIcon}`}></i> : mainImage ? <img src={mainImage} alt={altText} className='menu-img'/> :""}
                </Link> 
                    : ""}

                {/* <Link className='link-icon-style  c-utility-nav-label' to={`${profile?.transient ? '/account/login?resume=list' : '/account/list'}`} onClick={handleClick} style={{ cursor: "pointer" }}> */}
                    {/* <i class="fas fa-list-ul icon-profile-style"></i> */}
                    {/* <span className='d-block nav-text-hover' style={{ cursor: "pointer" }}>{ShoppingListDetails?.displayName ? ShoppingListDetails.displayName : ""}</span></Link> */}
                {profile && profile.transient ?
                    <div class="popover__content popover-list-content">
                        <p class="popover__message">Login or register now to maximize your savings and access profile information, order history, tracking, shopping lists, and more. </p>
                        <div className='text-end'>
                            <Link style={{ textDecoration: "none" }} to='/account/login?resume=list' onClick={handleListLogin} >
                                <button className='mx-1 btn btn-sm btn-color'>Login</button>
                            </Link>
                            <Link style={{ textDecoration: "none" }} to='/account/login?resume=list' onClick={handleListLogin} >
                                <button className='btn btn-sm btn-color'>Create an Account</button>
                            </Link>
                        </div>
                    </div>
                    : <>
                        <div className="popover__content popover-list-content">
                        { shoppingListDetailRef && shoppingListDetailRef.giftLists && <h6 className='contactfont-clr text-start'>Shopping Lists</h6>}
                            <p className="popover__message" dangerouslySetInnerHTML={{ __html: shoppingListDetailRef && shoppingListDetailRef.listMessage }}></p>
                           { shoppingListDetailRef && shoppingListDetailRef.giftLists &&
                            <ul class="list-unstyled shopping-list">
                                {shoppingListDetailRef && shoppingListDetailRef.giftLists &&
                                    shoppingListDetailRef.giftLists.map((data, value) => {
                                        return (<>
                                            <li class="">
                                                <Link rel="nofollow" to={`/account/list-detail?giftlistId=${data.giftListId}`}>
                                                    <div class="row">
                                                        <div class="col-12 shopping-list-title">{data.eventName}</div>
                                                        <div class="col-6 shopping-list-date">Created {data.comments}</div>
                                                        <div class="col-6 text-end shopping-list-count">{data.qty} items</div>
                                                    </div>
                                                </Link>
                                            </li>
                                        </>)
                                    })}
                            </ul>
                }

                            <div className='text-end'>
                                <Link style={{ textDecoration: "none" }}>
                                    {/* <button className='mx-1 btn btn-sm btn-color'>New List</button> */}
                                    <button type="button" className="mx-1 btn btn-sm btn-color" data-bs-toggle="modal" data-bs-target="#newListModal">New List</button>

                                </Link>
                                <Link to={`${profile && profile.transient ? "/account/login" : "/account/list"}`} style={{ textDecoration: "none" }}>
                                    <button className='btn btn-sm btn-color'>Manage Lists</button>
                                </Link>
                            </div>
                        </div>
                    </>}
            </li>
        </>
    )
}

export default ShoppingListsTile
